import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "reactstrap";

import { BillingEstimateStatus, isBillingValidationPending } from "./upcomingChargeTotals";
export { isBillingValidationPending } from "./upcomingChargeTotals";

export default function BillingOwnershipStatus({ estimate }: { estimate: BillingEstimateStatus }) {
  const { t } = useTranslation("dashboard", { keyPrefix: "upcomingCharges" });
  if (isBillingValidationPending(estimate)) return (
    <div role="status">
      <Badge color="warning">{t("validationPending")}</Badge>
      <div className="small text-muted">{t("validationPendingExplanation")}</div>
      {!!estimate.ownership?.reasons.length && <details className="small text-muted mt-1">
        <summary>{t("validationDetails")}</summary>
        {estimate.ownership.reasons.map((reason, index) => <div key={index}>{reason}</div>)}
      </details>}
    </div>
  );
  if (estimate.ownership?.excludedDeals) return <small className="text-muted">{t("manualDealsExcluded", { count: estimate.ownership.excludedDeals })}</small>;
  return null;
}
